export const platform = {
  routes: [
    {
      path: "/account",
      component: () => import("../profile-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/account-workspace-organization",
      component: () => import("../management-account-workspace-organization-view"),
    },
  ],
};
